export enum TeamRole {
  ADMIN = 0,
  MEMBER = 1,
  VIEWER = 2,
}
